import {
  Button,
  EmptyStates as DSEmptyStates,
  type EmptyStatesProps,
  Group,
  Icon,
} from '@inflearn/ds-react';
import { faRefresh } from '@inflearn/pro-regular-svg-icons';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  isError?: boolean;
  isEmpty?: boolean;
  empty?: EmptyStatesProps;
  error?: Partial<EmptyStatesProps>;
  height?: number;
  onRetry?: () => void;
};

export default function EmptyStates({
  children,
  isError = false,
  isEmpty = false,
  empty,
  error,
  height = 140,
  onRetry,
}: Props) {
  const { t } = useTranslation();
  const router = useRouter();

  if (isError) {
    return (
      <Group h={height} align="center" position="center">
        <DSEmptyStates
          image="ERROR"
          title={t('연결에 문제가 있어요')}
          body={t('잠시 후 다시 시도해주세요.')}
          cta={
            <Button
              variant="default"
              size="xs"
              radius="md"
              rightIcon={<Icon icon={faRefresh} size="xs" />}
              onClick={() => onRetry?.() || router.reload()}
            >
              {t('새로고침')}
            </Button>
          }
          {...error}
        />
      </Group>
    );
  }

  if (isEmpty && empty) {
    return (
      <Group h={height} align="center" position="center">
        <DSEmptyStates image="NO_DATA" {...empty} />
      </Group>
    );
  }

  return <>{children}</>;
}
